import { combineReducers } from "@reduxjs/toolkit";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BackendError, Notification } from "./types";
import { roomReducers } from "conference/components/meeting-page/room/redux";
import { defineMessage, MessageDescriptor } from "react-intl";

const emptyNotification: Notification = {
    show: false,
    message: defineMessage({ id: "notification.empty", defaultMessage: "No notification" }),
    variant: "success",
    messageVars: {},
};

const notificationSlice = createSlice({
    name: "notification",
    initialState: emptyNotification,
    reducers: {
        showNotification: (
            state,
            action: PayloadAction<{
                message: MessageDescriptor;
                variant?: Notification["variant"];
                vars?: Notification["messageVars"];
            }>,
        ) => {
            state.message = action.payload.message;
            state.variant = action.payload.variant || "success";
            state.show = true;
            state.messageVars = action.payload.vars || {};
        },
        hideNotification: (state) => {
            state.show = false;
        },
    },
});

const lastMeetingIdSlice = createSlice({
    name: "lastMeetingId",
    initialState: 0,
    reducers: {
        setLastMeetingId: (state, action: PayloadAction<number>) => {
            return action.payload;
        },
    },
});

const backendErrorSlice = createSlice({
    name: "backendError",
    initialState: null as BackendError | null,
    reducers: {
        setBackendError: (state, action: PayloadAction<BackendError>) => {
            return action.payload;
        },
    },
});

const themeSlice = createSlice({
    name: "theme",
    initialState: "light" as "light" | "dark",
    reducers: {
        setTheme: (state, action: PayloadAction<"light" | "dark">) => {
            return action.payload;
        },
    },
});

const rootReducer = combineReducers({
    notification: notificationSlice.reducer,
    lastMeetingId: lastMeetingIdSlice.reducer,
    backendError: backendErrorSlice.reducer,
    theme: themeSlice.reducer,
    room: roomReducers,
});

export default rootReducer;

// Export actions for use in components
export const { showNotification: showNotificationAction, hideNotification: hideNotificationAction } =
    notificationSlice.actions;
export const { setLastMeetingId: setLastMeetingIdAction } = lastMeetingIdSlice.actions;
export const { setBackendError: setBackendErrorAction } = backendErrorSlice.actions;
export const { setTheme: setThemeAction } = themeSlice.actions;
